module.exports = __webpack_public_path__ + "img/img_message.1942e5f3.png";